import { IAPIBaseInfo } from './APIBaseInfo';
import { IRequestParams } from './request';

class RequestConfig {
    public headers: HeadersInit = {};

    public getTimeout(): number {
        return 20 * 1000;
    }

    public getTimeoutMsg(): string {
        return '请求超时';
    }

    public getHeaders(): HeadersInit {
        return this.headers;
    }
    public setHeaders(headers: HeadersInit) {

        this.headers = {
            ...this.headers,
            ...headers
        };
    }

    public getCredentials(): RequestCredentials {
        return 'include';
    }

    public getPostContentType(): string {
        return 'application/json; charset=utf-8';
    }

    public getAPIBaseInfoBodyLength(): number {
        return 2048;
    }

    public handleLogin(): void {
        //
    }

    public getNeedLoginHTTPStatus(): number {
        return 401;
    }

    public loginCheck(resp): boolean {
        return true;
    }

    public handleSuccessAPIBaseInfo(abi: IAPIBaseInfo): void {
        //
    }

    public handleErrorAPIBaseInfo(abi: IAPIBaseInfo): void {
        //
    }

    public handleSendRequest(abi: IAPIBaseInfo): void {
        //
    }

    public handleRecieveResponse(abi: IAPIBaseInfo): void {
        //
    }
    public handleRedirectLogin(abi: IAPIBaseInfo): void {
        //
    }

    public getHostName() {
        return '';
    }

    public async isSend(p: IRequestParams<IPlainObject>): Promise<boolean> {
        return Promise.resolve(true);
    }
}

export const requestConfig = new RequestConfig();
